import {applyMiddleware, compose, createStore} from 'redux';

import middleware from './middleware';
import reducers from "./reducers";
import localize from './localize';

const enhancers = [];
const middlewareCompose = compose(
	applyMiddleware(...middleware),
	...enhancers
);

const store = localize(createStore(reducers, middlewareCompose));

export {store};



// WEBPACK FOOTER //
// ./src/store/index.js